<permission-checker [roles]="roles" (contentInit)="initContent()">
  <div class="content-holder">
    <mat-toolbar color="accent" class="page-toolbar" [class.mobile]="mobileView">
      <mat-toolbar-row class="toolbar-row">
        <h1 i18n="Coordinators List|Coordinators List title@@coordinators-list-title">Coordinators</h1>

        <div class="fill-space"></div>

        <app-button label="Assign Coordinator"
                    i18n-label="Coordinators List|Assign Coordinator button title@@coordinators-list-assign-coordinator-button-title"
                    color="primary"
                    [disabled]="!contest || !contestOpenForEnrol"
                    (clicked)="assignCoordinator(contest)"></app-button>
      </mat-toolbar-row>
    </mat-toolbar>

    <div class="content page">
      <contest-select-panel [competitionId]="competitionId"
                            [contest]="contest"
                            [mobileView]="mobileView"
                            (openForEnrolUpdated)="contestOpenForEnrol = $event"
                            (selected)="contestSelected($event)"></contest-select-panel>

      <app-no-content *ngIf="!coordinators && !inProgress"
                      [compact]="true"
                      title="Please select a contest from the list first"
                      i18n-title="Coordinators List|Select contest prompt@@coordinators-list-contest-prompt"
                      details="Coordinators will be loaded for the selected contest"
                      i18n-details="Coordinators List|Select contest prompt detail@@coordinators-list-contest-prompt-detail">
      </app-no-content>
      <app-no-content *ngIf="coordinators && !coordinators.length"
                      [compact]="true"
                      title="Selected contest doesn't have any coordinators assigned"
                      i18n-title="Coordinators List|Selected contest no coordinators title@@coordinators-list-contest-no-coordinators-title">

        <app-button label="Assign Coordinator"
                    i18n-label="Coordinators List|Assign Coordinator button title@@coordinators-list-assign-coordinator-button-title"
                    color="primary"
                    class="center create-cta"
                    [disabled]="!contest || !contestOpenForEnrol"
                    (clicked)="assignCoordinator(contest)"></app-button>
      </app-no-content>

      <users-table *ngIf="competitionId && contest && coordinators" #usersTable
                   [users]="coordinators"
                   [userRole]="COORDINATOR_ROLE"
                   [competitionId]="competitionId"
                   [contest]="contest"
                   [editAllowed]="true"
                   [deleteAllowed]="true"
                   [showLocation]="true"
                   [showPhone]="true"
                   [showStatus]="true"
                   (deleteRequested)="removeCoordinator($event, usersTable)"></users-table>

      <mat-spinner *ngIf="inProgress" color="primary" diameter="30" class="center"></mat-spinner>

      <div *ngIf="page && page.next_token" class="center-align">
        <app-link class="load-more-link"
                  label="load more"
                  icon="arrow_downward"
                  i18n-label="General|Load more action label@@general-load-more-action-label"
                  (click)="loadNextPage()"></app-link>
      </div>
    </div>
  </div>
</permission-checker>
